/* ==========================================================================
   Volta HYDRATE landing page behaviour.

   Ported from landing-page/index.html with one change: the symptom -> icon
   map is no longer hardcoded. Each symptom carries its Font Awesome classes
   in data-icon, set from the section block settings, so merchants can add or
   reorder symptoms in the theme editor without touching JS.
   ========================================================================== */

(function () {
  'use strict';

  /* ---- Block 1 selections drive the Block 7 outcome list ---- */
  function initSelectedOutcomes() {
    var symptoms = document.querySelectorAll('.landing-block-1 .item');
    var list = document.getElementById('selected-benefits');
    var count = document.getElementById('selected-count');
    if (!symptoms.length || !list || !count) return;

    function update() {
      var selected = [];

      symptoms.forEach(function (item) {
        var checkbox = item.querySelector('.toggle');
        if (!checkbox || !checkbox.checked) return;
        var outcome = item.querySelector('.expectation-card');
        if (!outcome) return;
        selected.push({
          icon: item.getAttribute('data-icon') || 'fa-solid fa-circle-check',
          text: outcome.textContent.trim()
        });
      });

      count.textContent = selected.length;
      list.replaceChildren();

      selected.forEach(function (entry, index) {
        var li = document.createElement('li');
        li.style.animationDelay = Math.min(index * 35, 280) + 'ms';

        var check = document.createElement('span');
        check.className = 'check';
        check.innerHTML = '<i class="fa-solid fa-check"></i>';

        var icon = document.createElement('span');
        icon.className = 'benefit-icon';
        var i = document.createElement('i');
        i.className = entry.icon;
        icon.appendChild(i);

        var text = document.createElement('span');
        text.className = 'benefit-text';
        text.textContent = entry.text;

        li.append(check, icon, text);
        list.appendChild(li);
      });
    }

    document.querySelectorAll('.landing-block-1 .toggle').forEach(function (box) {
      box.addEventListener('change', update);
    });
    update();
  }

  /* ---- Gentle section entrance as the visitor moves down the page ---- */
  function initSectionReveal() {
    var sections = document.querySelectorAll('.landing-section');
    if (!sections.length) return;

    document.body.classList.add('page-enhanced');

    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (section) { section.classList.add('section-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add('section-visible');
      });
    }, { rootMargin: '8% 0px -12% 0px', threshold: 0.08 });

    sections.forEach(function (section, index) {
      if (index === 0) section.classList.add('section-visible');
      observer.observe(section);
    });
  }

  /* ---- Sticky "Try Volta HYDRATE" bar ---- */
  function initStickyCta() {
    var sticky = document.getElementById('volta-sticky-cta');
    if (!sticky) return;

    var closeBtn = document.getElementById('volta-sticky-cta-close');
    /* Show after the first block scrolls away, hide once the offer block
       (or, if it is absent, the last block on the page) comes into view. */
    var startAfter = document.querySelector('.landing-block-1');
    var stopAt = document.querySelector('.landing-block-12');
    var sections = document.querySelectorAll('.landing-section');
    if (!stopAt && sections.length) stopAt = sections[sections.length - 1];
    if (!closeBtn || !startAfter || !stopAt || startAfter === stopAt) return;

    var dismissKey = 'voltaStickyCtaDismissed';

    function isDismissed() {
      try { return sessionStorage.getItem(dismissKey) === '1'; }
      catch (e) { return sticky.dataset.dismissed === '1'; }
    }
    function setDismissed() {
      sticky.dataset.dismissed = '1';
      try { sessionStorage.setItem(dismissKey, '1'); } catch (e) {}
    }
    function setVisible(show) {
      var visible = show && !isDismissed();
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('sticky-volta-visible', visible);
    }

    function updateStickyCta() {
      /* Rects, not offsetTop: every block sits inside a position:relative
         .section-band, so offsetTop measures from the band rather than the
         page and would read ~0. */
      var pastStart = startAfter.getBoundingClientRect().bottom <= 0;
      var atStop = stopAt.getBoundingClientRect().top <= window.innerHeight;
      setVisible(pastStart && !atStop);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { updateStickyCta(); ticking = false; });
    }

    closeBtn.addEventListener('click', function () { setDismissed(); setVisible(false); });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', updateStickyCta);
    updateStickyCta();
  }

  function init() {
    initSelectedOutcomes();
    initSectionReveal();
    initStickyCta();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-bind when the theme editor swaps a section in or out. */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
})();
